import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError, pipe, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationService } from '../../core/services/authentication.service';
import { GenericService } from '@app/core/services/generic.service';

import { Status, Loading, Historico } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoService extends GenericService<any> {

  private avaliacaoRealizada = new BehaviorSubject<any>(false);

  constructor(http: HttpClient, private auth: AuthenticationService) {
    super('censo/autoAtendimento', http);
  };

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}`;
  }

  status(loading?: Loading): Observable<Status> {
    this.startLoading(loading);
    return this.getHttpClient().get<Status[]>(`${this.apiBase}/status`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  voltarParaEtapaDois(loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${this.apiBase}/retornarEtapa2`, null)
      .pipe(this.configMapAndLoading(loading));
  }

  finalizar(loading?: Loading): Observable<Status> {
    this.startLoading(loading);
    return this.getHttpClient().put(`${this.apiBase}/finalizar`, null)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  historicos(loading?: Loading): Observable<Historico[]> {
    this.startLoading(loading);
    return this.getHttpClient().get<Historico[]>(`${this.apiBase}/historicos`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  result(): any {
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
  }

  imprimirComprovante(loading?: Loading): Observable<Blob> {
    this.startLoading(loading);
    return this.getHttpClient().get(`${this.apiBase}/comprovante`, { headers: this.getHeadersPDF(), responseType: 'blob' })
      .pipe(this.configMapAndLoading(loading));
  }

  buscarAvaliacaoAtendimento(loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient().get<any>(`${this.apiBase}/avaliacao`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  enviarAvaliacaoAtendimento(notaAtendimento: number, loading?: Loading): Observable<number> {
    this.startLoading(loading);
    return this.getHttpClient().post(`${ this.apiBase }/avaliacao`, notaAtendimento)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  setAvaliacao(avaliado: boolean): void {
    this.avaliacaoRealizada.next(avaliado);
  }

  getStatusAvaliacao(): Observable<boolean> {
    return this.avaliacaoRealizada.asObservable();
  }
}
